import React from "react";

export const Xmark = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 13.4403L17.7614 19.2017C18.1591 19.5994 18.804 19.5994 19.2017 19.2017C19.5994 18.8039 19.5994 18.1591 19.2017 17.7613L13.4404 12L19.2017 6.23865C19.5994 5.84092 19.5994 5.19605 19.2017 4.79832C18.804 4.40058 18.1591 4.40058 17.7614 4.79832L12.0001 10.5597L6.23864 4.7983C5.84091 4.40057 5.19604 4.40057 4.7983 4.7983C4.40057 5.19604 4.40057 5.8409 4.7983 6.23864L10.5596 12L4.7983 17.7614C4.40057 18.1591 4.40057 18.8039 4.7983 19.2017C5.19604 19.5994 5.84091 19.5994 6.23864 19.2017L12.0001 13.4403Z"
        fill="white"
      />
    </svg>
  );
};
